<template>
  <div class="container">
    <div class="flex-col align-start">
      <div class="title flex-row justify-between">
        <el-checkbox
          :indeterminate="listAllSelect.isIndeterminate"
          v-model="listAllSelect.state"
          @change="handleCheckedAllChange"
          class="label"
        >
          <span style="font-size: 16px">
            {{ listAllSelect.label }}
          </span>
        </el-checkbox>
        <div class="number">
          {{ checkedList.length }}/{{ list.length }}
        </div>
      </div>
      <div class="flex-col align-start">
        <el-checkbox
          class="option"
          v-for="item of list"
          :label="item.label"
          :key="item.value"
          v-model="item.state"
          @change="handleCheckedChange(item)"
        >{{ item.label }}</el-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "multipleChoiceList",
  props: {
    checkedList: {
      type: Array
    },
    list: {
      type: Array,
    },
    listAllSelect: {
      type: Object
    },
    handleListAllSelected: {
      type: Function
    },
    handleListSelected: {
      type: Function
    }
  },
  data() {
    return {

    }
  },
  methods: {
    // 全选
    handleCheckedAllChange(val) {
      this.handleListAllSelected(val)
    },

    // 单选
    handleCheckedChange(item) {
      this.handleListSelected(item)
    }
  }
}

</script>

<style lang="scss" src="../css/multipleChoiceList.scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/multipleChoiceList.vue